import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { currentSession, onSessionChange } from "./lib/auth";
import { I18nProvider } from "./lib/i18n";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (count, error) =>
        count < 2 &&
        (!(error instanceof Error) ||
          !("status" in error) ||
          Number(error.status) >= 500),
      refetchOnWindowFocus: false,
    },
  },
});
// Everything cached belongs to whoever was signed in when it was read. Signing out, or in as
// another account in the same tab, must not show one restaurant another's figures — not even
// for the moment before a refetch, which the server then refuses and leaves the old data up.
let cachedFor = currentSession()?.id ?? null;
onSessionChange(() => {
  const now = currentSession()?.id ?? null;
  if (now !== cachedFor) {
    cachedFor = now;
    queryClient.clear();
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
);
